import { render, staticRenderFns } from "./AddClueRecord.vue?vue&type=template&id=4be4d06a&"
import script from "./AddClueRecord.vue?vue&type=script&lang=js&"
export * from "./AddClueRecord.vue?vue&type=script&lang=js&"
import style0 from "./AddClueRecord.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports